import script from "./WorkspaceView.vue?vue&type=script&lang=ts&setup=true"
export * from "./WorkspaceView.vue?vue&type=script&lang=ts&setup=true"

import "./WorkspaceView.vue?vue&type=style&index=0&id=885b6540&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-885b6540"]])

export default __exports__